import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, updateDoc, collection, Timestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

import { Randomcode } from '../../components/rendom_code';
import { Helmet } from "react-helmet";
import Lodinging from "../../components/loading";
import Cookies from 'js-cookie';
import { useToast } from '../../components/ToastContext';
import Statusbarpopup from '../../master_root/statusbarpopup';
import { VscAdd, VscClose } from 'react-icons/vsc';
import { Createauthorizedrole } from './create_authorized_role';

export default function Usersauthorized({ data, onClose }) {
  const puid = data?.puid;
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [taskname, setTaskname] = useState('');
  const [description, setdescription] = useState('');
  const [taskdata, setTaskdata] = useState([]);
  const [selectedColor, setSelectedColor] = useState("#3B82F6");
  const [rolename, setrolename] = useState('');
  const [duedate, setDuedate] = useState(Timestamp.now().toDate());
  const [permissions, setPermissions] = useState({});
  const capitalizeFirst = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  //color 
  const handleCreate = async (color) => {
    if (!rolename.trim() || !permissions) {
      showToast("Please enter both rolename and permissions.");
      return;
    }

    try {
      Object.entries(permissions).forEach(async ([key, value]) => {
        console.log(`Permission: ${key}, Allowed: ${value}`);
        setLoading(true);
        if (value === true) {
        const uid = Randomcode(16); // Fallback for Randomcode
        const result = await Createauthorizedrole({ uid,permissions:key , accountguid: data.guid, color: selectedColor, rolename });

        if (result.success) {
          showToast("Successfully");
onClose();
        } else {
          showToast("Failed: " + (result.error || "Unknown error"));
        }
        }
      });
    } catch (ex) {
      console.error("An error occurred:", ex);
    } finally {
      setLoading(false);
    }
  };

  //color 
  const handleColorClick = (color) => {
    setSelectedColor(color);
    console.log("Selected Color:", color); // or pass it to parent component
  };
  const colorList = [
    '#3B82F6', // Blue (Primary)
    '#10B981', // Emerald (Success)
    '#F59E0B', // Amber (Warning)
    '#EF4444', // Red (Error)
    '#6366F1', // Indigo
    '#8B5CF6', // Violet
    '#EC4899', // Pink
    '#F43F5E', // Rose
    '#0EA5E9', // Sky Blue
    '#14B8A6', // Teal
    '#22C55E', // Green
    '#EAB308', // Yellow
    '#F97316', // Orange
    '#1F2937', // Dark Slate (Text/Base)
    '#A3A3A3', // Cool Gray
    '#6B7280', // Gray
    '#94A3B8', // Slate Gray
    '#D4D4D8', // Light Gray 
  ];
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <Statusbarpopup data={'User Authorized'} />
        <div className="container_roots">
          <Helmet>
            <title>Browse Job Tasks | EditorTask - Find & Hire Creative Talent</title>

            <meta name="description" content="Discover the latest freelance job tasks listed on EditorTask. From video editing to digital marketing, connect with top talent across India." />
            <meta name="keywords" content="job listings, freelance tasks, hire editors, creative work, India job portal, remote jobs, task board, EditorTask jobs" />
            <meta name="author" content="editortask.com" />
            <meta name="robots" content="index, follow" />

            <meta property="og:title" content="Browse Job Tasks | EditorTask - Find & Hire Creative Talent" />
            <meta property="og:description" content="Explore freelance and project-based job tasks posted on EditorTask. Connect with skilled editors, designers, marketers, and more." />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://www.editortask.com/jobs" />
            <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
          </Helmet>

          <div className="container_size">
            <br />
            <div className='post-container'  >
              <div className='post_div'>

                <table style={{ borderTop: `solid 4px ${selectedColor}` }}>
                  <br />
                  <tbody>
                    {[
                      
                      { key: 'createproject', label: 'Create Project' }, 
                      { key: 'addusers', label: 'Add New Users' },
                      { key: 'assigntasks', label: 'Assign Tasks' },
                      { key: 'editowntasks', label: 'Edit Own Tasks' },
                      { key: 'reviewtask', label: 'Review Task ' },
                      { key: 'finalapproval', label: 'Final Task Approval ' },
                      { key: 'viewreports', label: 'View Reports' },
                      { key: 'manageroles', label: 'Manage Roles & Permissions' },
                      { key: 'accessfinance', label: 'Access Financial Dashboard' },
                    ].map((item, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type='checkbox'
                            className='projects-input-box'
                            checked={permissions[item.key] || false}
                            onChange={(e) =>
                              setPermissions({ ...permissions, [item.key]: e.target.checked })
                            }
                          />
                        </td>
                        <td className='contact-header'>{item.label}</td>
                      </tr>
                    ))}
                    <br />
                    <tr>
                      <td colSpan={2}>
                        <input
                          className='projects-input-box'
                          maxLength={30}

                          placeholder='Role name'
                          value={rolename}
                          onChange={(e) => setrolename(e.target.value)}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={2}>
                        <table>
                          <tbody>
                            <tr>
                              {colorList.map((color, index) => (
                                <td key={index}>
                                  <div
                                    onClick={() => handleColorClick(color)}
                                    style={{
                                      width: '20px',
                                      height: '20px',
                                      borderRadius: '100%',
                                      backgroundColor: color,
                                      cursor: 'pointer',
                                      border: selectedColor === color
                                        ? '2px solid #333'
                                        : `1px solid ${color}`,
                                      margin: '2px'
                                    }}
                                  />
                                </td>
                              ))}
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={2}>
                        <br />
                        <div className='button-ui' onClick={handleCreate}>
                          <VscAdd className='icon' /> {loading ? 'Saveing...' : 'Save'}
                        </div>

                        <div className='button-ui3' style={{ marginLeft: '20px' }} onClick={onClose}>
                          <VscClose className='icon' /> {loading ? 'Creating...' : 'Close'}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
